// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lumina Library — My Images (Stitch design tokens, no sidebar) */

.images-library-scope {
  --lumina-bg: #ffffff;
  --lumina-surface: #ffffff;
  --lumina-on-surface: #0f172a;
  --lumina-on-surface-variant: #64748b;
  --lumina-primary: #0f172a;
  --lumina-on-primary: #ffffff;
  --lumina-primary-container: #2563eb;
  --lumina-secondary-container: #64748b;
  --lumina-outline-variant: rgba(15, 23, 42, 0.14);
  --lumina-surface-container: #f1f5f9;
  --lumina-surface-container-high: #e4e1d9;
  --lumina-surface-container-low: #ffffff;
  --lumina-inverse-surface: #0f172a;
  --lumina-inverse-on-surface: #ffffff;
  --lumina-error: #8a5a2b;
  --lumina-gutter: 1.5rem;
  --lumina-margin: 1rem;
  font-family: "Outfit", "Segoe UI", system-ui, -apple-system, sans-serif;
  background-color: var(--lumina-bg);
  color: var(--lumina-on-surface);
  transition: background-color 0.2s ease, color 0.2s ease;
}

html.dark .images-library-scope {
  --lumina-bg: #151412;
  --lumina-surface: #1c1a18;
  --lumina-on-surface: #ffffff;
  --lumina-on-surface-variant: #a8a399;
  --lumina-primary: #ffffff;
  --lumina-on-primary: #0f172a;
  --lumina-primary-container: #e2e8f0;
  --lumina-secondary-container: #94a3b8;
  --lumina-outline-variant: rgba(255, 255, 255, 0.12);
  --lumina-surface-container: #1d4ed8;
  --lumina-surface-container-high: #332f2a;
  --lumina-surface-container-low: #1c1a18;
  --lumina-inverse-surface: #ffffff;
  --lumina-inverse-on-surface: #0f172a;
}

@media (min-width: 768px) {
  .images-library-scope {
    --lumina-margin: 3rem;
  }
}

.images-library-scope .lumina-glass {
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

html.dark .images-library-scope .lumina-glass {
  background: rgba(30, 41, 59, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.35);
}

.images-library-scope .lumina-primary-glow {
  box-shadow: 0 0 20px rgba(99, 14, 212, 0.28);
}

.images-library-scope .lumina-pulse-dot {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: var(--lumina-primary);
}

.images-library-scope .lumina-pulse-dot::after {
  content: '';
  position: absolute;
  inset: -4px;
  border-radius: 9999px;
  background: var(--lumina-primary);
  opacity: 0.4;
  animation: lumina-pulse 2s ease-in-out infinite;
}

@keyframes lumina-pulse {
  0%,
  100% {
    transform: scale(0.9);
    opacity: 0.25;
  }
  50% {
    transform: scale(1.5);
    opacity: 0;
  }
}

/* Hero */
.images-library-scope .lumina-hero {
  position: relative;
  overflow: hidden;
  border-radius: 1.5rem;
  margin-bottom: 2rem;
  padding: 2rem;
}

.images-library-scope .lumina-hero-glow {
  position: absolute;
  top: 0;
  right: 0;
  width: 24rem;
  height: 24rem;
  transform: translate(25%, -50%);
  border-radius: 9999px;
  background: rgba(99, 14, 212, 0.1);
  filter: blur(80px);
  pointer-events: none;
}

html.dark .images-library-scope .lumina-hero-glow {
  background: rgba(139, 92, 246, 0.15);
}

/* Tailwind arbitrary colors in ImagesPage.tsx */
html.dark .images-library-scope .text-\\[\\#191c1e\\] {
  color: var(--lumina-on-surface) !important;
}

html.dark .images-library-scope .text-\\[\\#4a4455\\],
html.dark .images-library-scope .text-\\[\\#7b7487\\] {
  color: var(--lumina-on-surface-variant) !important;
}

html.dark .images-library-scope .text-\\[\\#0f172a\\] {
  color: var(--lumina-primary) !important;
}

html.dark .images-library-scope .bg-\\[\\#eceef0\\] {
  background-color: var(--lumina-surface-container) !important;
}

/* Toolbar */
.images-library-scope .lumina-view-toggle {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-radius: 0.75rem;
  border: 1px solid rgba(204, 195, 216, 0.35);
  background: rgba(255, 255, 255, 0.5);
}

html.dark .images-library-scope .lumina-view-toggle {
  border-color: rgba(71, 85, 105, 0.5);
  background: rgba(30, 41, 59, 0.6);
}

.images-library-scope .lumina-view-toggle button {
  padding: 0.5rem;
  border-radius: 0.5rem;
  color: var(--lumina-on-surface-variant);
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}

.images-library-scope .lumina-view-toggle button.lumina-view-toggle--active {
  background: var(--lumina-surface);
  color: var(--lumina-primary);
  box-shadow: 0 1px 3px rgba(25, 28, 30, 0.08);
}

.images-library-scope .lumina-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--lumina-on-surface);
  background: var(--lumina-surface-container-high);
  transition: background 0.2s, transform 0.15s;
}

.images-library-scope .lumina-btn-secondary:hover {
  background: #d8dadc;
}

html.dark .images-library-scope .lumina-btn-secondary:hover {
  background: var(--lumina-surface-container-high);
}

.images-library-scope .lumina-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.25rem;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--lumina-on-primary);
  background: var(--lumina-primary);
  transition: transform 0.15s, box-shadow 0.2s;
}

.images-library-scope .lumina-btn-primary:hover {
  transform: scale(1.02);
}

.images-library-scope .lumina-btn-primary:active {
  transform: scale(0.98);
}

/* Source chips */
.images-library-scope .lumina-source-active {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--lumina-inverse-on-surface);
  background: var(--lumina-inverse-surface);
  box-shadow: 0 1px 3px rgba(25, 28, 30, 0.12);
}

.images-library-scope .lumina-source-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--lumina-on-surface-variant);
  background: var(--lumina-surface-container-low);
  border: 1px solid rgba(204, 195, 216, 0.35);
  transition: border-color 0.2s, color 0.2s;
}

.images-library-scope .lumina-source-chip:hover {
  border-color: rgba(99, 14, 212, 0.45);
  color: var(--lumina-on-surface);
}

.images-library-scope .lumina-source-avatar {
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  font-size: 0.625rem;
  font-weight: 700;
  background: rgba(99, 14, 212, 0.12);
  color: var(--lumina-primary);
}

/* Sticky gallery bar */
.images-library-scope .lumina-gallery-bar {
  position: sticky;
  top: 0;
  z-index: 40;
  margin-bottom: 1.5rem;
  margin-left: calc(-1 * var(--lumina-margin));
  margin-right: calc(-1 * var(--lumina-margin));
  padding: 0.75rem var(--lumina-margin);
}

.images-library-scope .lumina-field {
  padding: 0.5rem 0.875rem 0.5rem 2.25rem;
  border-radius: 0.75rem;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--lumina-on-surface);
  background: var(--lumina-surface-container);
  outline: none;
  transition: box-shadow 0.2s;
}

.images-library-scope .lumina-field:focus {
  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.2);
}

.images-library-scope .lumina-select {
  padding: 0.5rem 0.875rem 0.5rem 2.25rem;
  border-radius: 0.75rem;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--lumina-on-surface);
  background: var(--lumina-surface-container);
  outline: none;
  appearance: none;
  min-width: 9rem;
}

.images-library-scope .lumina-select:focus {
  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.2);
}

/* Day header */
.images-library-scope .lumina-day-title {
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--lumina-on-surface);
}

.images-library-scope .lumina-day-meta {
  margin-left: 0.5rem;
  font-weight: 400;
  opacity: 0.6;
  color: var(--lumina-on-surface-variant);
}

/* Fixed-width columns — balanced size (no 1fr stretch) */
.images-library-scope .lumina-gallery-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(auto-fill, 10.5rem);
  justify-content: start;
}

@media (min-width: 640px) {
  .images-library-scope .lumina-gallery-grid {
    gap: 0.875rem;
    grid-template-columns: repeat(auto-fill, 11.5rem);
  }
}

@media (min-width: 1280px) {
  .images-library-scope .lumina-gallery-grid {
    grid-template-columns: repeat(auto-fill, 12rem);
  }
}

.images-library-scope .lumina-gallery-grid--compact {
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fill, 8.75rem);
}

@media (min-width: 640px) {
  .images-library-scope .lumina-gallery-grid--compact {
    grid-template-columns: repeat(auto-fill, 9.5rem);
  }
}

/* Skeleton card in grid */
.images-library-scope .lumina-skeleton-card {
  overflow: hidden;
  border-radius: 0.75rem;
  border: 1px solid rgba(204, 195, 216, 0.25);
  background: var(--lumina-surface);
}

.images-library-scope .lumina-skeleton-card .lumina-skeleton-media {
  aspect-ratio: 4 / 3;
}

.images-library-scope .lumina-skeleton-card .lumina-skeleton-footer {
  height: 2.25rem;
  border-top: 1px solid rgba(204, 195, 216, 0.2);
}

/* Sticky top bar (no left sidebar) */
.images-library-scope .lumina-top-bar {
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom: 1px solid rgba(204, 195, 216, 0.35);
  background: rgba(247, 249, 251, 0.88);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

html.dark .images-library-scope .lumina-top-bar {
  border-bottom-color: rgba(71, 85, 105, 0.6);
  background: rgba(15, 23, 42, 0.9);
}

.images-library-scope .lumina-top-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem 0.375rem 0.625rem;
  border-radius: 9999px;
  background: var(--lumina-surface-container);
  transition: box-shadow 0.2s;
}

.images-library-scope .lumina-top-search:focus-within {
  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.2);
}

.images-library-scope .lumina-top-search input {
  width: 100%;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 0.875rem;
  color: var(--lumina-on-surface);
  outline: none;
}

@media (min-width: 640px) {
  .images-library-scope .lumina-top-search input {
    width: 12rem;
  }
}

@media (min-width: 1024px) {
  .images-library-scope .lumina-top-search input {
    width: 16rem;
  }
}

.images-library-scope .lumina-page-body {
  width: 100%;
  max-width: 100%;
  padding-left: var(--lumina-margin);
  padding-right: var(--lumina-margin);
  padding-top: 1.25rem;
  padding-bottom: 2rem;
}

/* Gallery card */
.images-library-scope .lumina-gallery-card {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 1rem;
  border: 1px solid rgba(204, 195, 216, 0.25);
  background: var(--lumina-surface);
  box-shadow: 0 1px 2px rgba(25, 28, 30, 0.05);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  user-select: none;
  -webkit-user-select: none;
}

.images-library-scope .lumina-gallery-card img,
.images-library-scope .lumina-gallery-card video {
  -webkit-user-drag: none;
  user-drag: none;
  pointer-events: none;
}

.images-library-scope .lumina-marquee-surface {
  cursor: default;
}

.images-library-scope .lumina-marquee-surface--active {
  cursor: crosshair;
  user-select: none;
  -webkit-user-select: none;
}

.images-library-scope .lumina-marquee-box {
  pointer-events: none;
}

.images-library-scope .lumina-gallery-card:hover {
  box-shadow: 0 12px 28px -8px rgba(99, 14, 212, 0.18);
  transform: translateY(-2px);
}

.images-library-scope .lumina-gallery-card--selected {
  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.45), 0 12px 28px -8px rgba(99, 14, 212, 0.15);
}

.images-library-scope .lumina-gallery-card .lumina-media {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: var(--lumina-surface-container);
}

.images-library-scope .lumina-gallery-card .lumina-media img,
.images-library-scope .lumina-gallery-card .lumina-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.images-library-scope .lumina-gallery-card:hover .lumina-media img,
.images-library-scope .lumina-gallery-card:hover .lumina-media video {
  transform: scale(1.05);
}

.images-library-scope .lumina-gallery-card .lumina-media-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent 55%);
  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.images-library-scope .lumina-gallery-card:hover .lumina-media-overlay {
  opacity: 1;
}

.images-library-scope .lumina-ext-badge {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  z-index: 2;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
}

.images-library-scope .lumina-card-select {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 3;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.images-library-scope .lumina-gallery-card:hover .lumina-card-select,
.images-library-scope .lumina-gallery-card--selected .lumina-card-select {
  opacity: 1;
}

.images-library-scope .lumina-card-actions {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  z-index: 3;
  display: flex;
  gap: 0.375rem;
  opacity: 0;
  transform: translateY(4px);
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.images-library-scope .lumina-gallery-card:hover .lumina-card-actions {
  opacity: 1;
  transform: translateY(0);
}

.images-library-scope .lumina-action-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: background 0.2s, transform 0.15s;
}

.images-library-scope .lumina-action-icon:hover {
  background: rgba(0, 0, 0, 0.65);
  transform: scale(1.06);
}

.images-library-scope .lumina-action-icon--danger:hover {
  background: rgba(186, 26, 26, 0.85);
}

.images-library-scope .lumina-card-footer {
  padding: 0.625rem 0.75rem;
}

.images-library-scope .lumina-card-filename {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--lumina-on-surface);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.images-library-scope .lumina-card-meta {
  margin-top: 0.125rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--lumina-on-surface-variant);
}

.images-library-scope .lumina-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, #eceef0 0%, #f7f9fb 45%, #eceef0 90%);
  background-size: 200% 100%;
  animation: lumina-shimmer 1.4s ease-in-out infinite;
}

@keyframes lumina-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.images-library-scope .lumina-empty {
  border-radius: 1.25rem;
  border: 2px dashed rgba(204, 195, 216, 0.6);
  background: rgba(255, 255, 255, 0.55);
  padding: 3.5rem 1.5rem;
  text-align: center;
}

.images-library-scope .lumina-stat-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--lumina-on-surface-variant);
  background: var(--lumina-surface-container-high);
}

/* Lightbox */
.images-library-scope .lumina-lightbox-chrome {
  background: linear-gradient(180deg, rgba(25, 28, 30, 0.88) 0%, transparent 100%);
}

.images-library-scope .lumina-lightbox-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  padding: 0.25rem;
  border-radius: 9999px;
  background: rgba(25, 28, 30, 0.55);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.images-library-scope .lumina-lightbox-pill button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  color: rgba(255, 255, 255, 0.88);
  transition: background 0.2s, color 0.2s;
}

.images-library-scope .lumina-lightbox-pill button:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.images-library-scope .lumina-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 9999px;
  color: var(--lumina-primary);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 20px rgba(25, 28, 30, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
}

.images-library-scope .lumina-nav-btn:hover {
  transform: scale(1.06);
}

/* Legacy aliases used in modals */
.images-library-scope .il-primary-gradient {
  background: linear-gradient(135deg, #0f172a, #2563eb);
  color: #fff;
}

.images-library-scope .il-shadow-elegant {
  box-shadow: 0 0 20px rgba(15, 23, 42, 0.16);
}

/* Legacy purple accent classes → ink */
.images-library-scope .text-\\[\\#630ed4\\],
.images-library-scope .text-\\[\\#7c3aed\\] {
  color: var(--lumina-primary) !important;
}
.images-library-scope .bg-\\[\\#630ed4\\],
.images-library-scope .bg-\\[\\#7c3aed\\] {
  background-color: var(--lumina-primary) !important;
  color: var(--lumina-on-primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/imagesPageTheme.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;EAC5B,mCAAmC;EACnC,qCAAqC;EACrC,gDAAgD;EAChD,mCAAmC;EACnC,wCAAwC;EACxC,uCAAuC;EACvC,iCAAiC;EACjC,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,uEAAuE;EACvE,kCAAkC;EAClC,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;EAC5B,mCAAmC;EACnC,qCAAqC;EACrC,mDAAmD;EACnD,mCAAmC;EACnC,wCAAwC;EACxC,uCAAuC;EACvC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE;;IAEE,qBAAqB;IACrB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gDAAgD;AAChD;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,uCAAuC;EACvC,wDAAwD;AAC1D;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,+CAA+C;EAC/C,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qBAAqB;EACrB,4CAA4C;EAC5C,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;AACzC;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,YAAY;EACZ,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,kDAAkD;EAClD,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2CAA2C;EAC3C,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,4CAA4C;EAC5C,qDAAqD;EACrD,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wEAAwE;EACxE,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,aAAa;EACb,aAAa;EACb,UAAU;EACV,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yEAAyE;EACzE,0BAA0B;EAC1B,mDAAmD;AACrD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA,aAAa;AACb;EACE,gFAAgF;AAClF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,qCAAqC;EACrC,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;;EAEE,uCAAuC;AACzC;AACA;;EAEE,kDAAkD;EAClD,0CAA0C;AAC5C","sourcesContent":["/* Lumina Library — My Images (Stitch design tokens, no sidebar) */\n\n.images-library-scope {\n  --lumina-bg: #ffffff;\n  --lumina-surface: #ffffff;\n  --lumina-on-surface: #0f172a;\n  --lumina-on-surface-variant: #64748b;\n  --lumina-primary: #0f172a;\n  --lumina-on-primary: #ffffff;\n  --lumina-primary-container: #2563eb;\n  --lumina-secondary-container: #64748b;\n  --lumina-outline-variant: rgba(15, 23, 42, 0.14);\n  --lumina-surface-container: #f1f5f9;\n  --lumina-surface-container-high: #e4e1d9;\n  --lumina-surface-container-low: #ffffff;\n  --lumina-inverse-surface: #0f172a;\n  --lumina-inverse-on-surface: #ffffff;\n  --lumina-error: #8a5a2b;\n  --lumina-gutter: 1.5rem;\n  --lumina-margin: 1rem;\n  font-family: \"Outfit\", \"Segoe UI\", system-ui, -apple-system, sans-serif;\n  background-color: var(--lumina-bg);\n  color: var(--lumina-on-surface);\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\nhtml.dark .images-library-scope {\n  --lumina-bg: #151412;\n  --lumina-surface: #1c1a18;\n  --lumina-on-surface: #ffffff;\n  --lumina-on-surface-variant: #a8a399;\n  --lumina-primary: #ffffff;\n  --lumina-on-primary: #0f172a;\n  --lumina-primary-container: #e2e8f0;\n  --lumina-secondary-container: #94a3b8;\n  --lumina-outline-variant: rgba(255, 255, 255, 0.12);\n  --lumina-surface-container: #1d4ed8;\n  --lumina-surface-container-high: #332f2a;\n  --lumina-surface-container-low: #1c1a18;\n  --lumina-inverse-surface: #ffffff;\n  --lumina-inverse-on-surface: #0f172a;\n}\n\n@media (min-width: 768px) {\n  .images-library-scope {\n    --lumina-margin: 3rem;\n  }\n}\n\n.images-library-scope .lumina-glass {\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\nhtml.dark .images-library-scope .lumina-glass {\n  background: rgba(30, 41, 59, 0.82);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n}\n\n.images-library-scope .lumina-primary-glow {\n  box-shadow: 0 0 20px rgba(99, 14, 212, 0.28);\n}\n\n.images-library-scope .lumina-pulse-dot {\n  position: relative;\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: var(--lumina-primary);\n}\n\n.images-library-scope .lumina-pulse-dot::after {\n  content: '';\n  position: absolute;\n  inset: -4px;\n  border-radius: 9999px;\n  background: var(--lumina-primary);\n  opacity: 0.4;\n  animation: lumina-pulse 2s ease-in-out infinite;\n}\n\n@keyframes lumina-pulse {\n  0%,\n  100% {\n    transform: scale(0.9);\n    opacity: 0.25;\n  }\n  50% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n}\n\n/* Hero */\n.images-library-scope .lumina-hero {\n  position: relative;\n  overflow: hidden;\n  border-radius: 1.5rem;\n  margin-bottom: 2rem;\n  padding: 2rem;\n}\n\n.images-library-scope .lumina-hero-glow {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 24rem;\n  height: 24rem;\n  transform: translate(25%, -50%);\n  border-radius: 9999px;\n  background: rgba(99, 14, 212, 0.1);\n  filter: blur(80px);\n  pointer-events: none;\n}\n\nhtml.dark .images-library-scope .lumina-hero-glow {\n  background: rgba(139, 92, 246, 0.15);\n}\n\n/* Tailwind arbitrary colors in ImagesPage.tsx */\nhtml.dark .images-library-scope .text-\\[\\#191c1e\\] {\n  color: var(--lumina-on-surface) !important;\n}\n\nhtml.dark .images-library-scope .text-\\[\\#4a4455\\],\nhtml.dark .images-library-scope .text-\\[\\#7b7487\\] {\n  color: var(--lumina-on-surface-variant) !important;\n}\n\nhtml.dark .images-library-scope .text-\\[\\#0f172a\\] {\n  color: var(--lumina-primary) !important;\n}\n\nhtml.dark .images-library-scope .bg-\\[\\#eceef0\\] {\n  background-color: var(--lumina-surface-container) !important;\n}\n\n/* Toolbar */\n.images-library-scope .lumina-view-toggle {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem;\n  border-radius: 0.75rem;\n  border: 1px solid rgba(204, 195, 216, 0.35);\n  background: rgba(255, 255, 255, 0.5);\n}\n\nhtml.dark .images-library-scope .lumina-view-toggle {\n  border-color: rgba(71, 85, 105, 0.5);\n  background: rgba(30, 41, 59, 0.6);\n}\n\n.images-library-scope .lumina-view-toggle button {\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  color: var(--lumina-on-surface-variant);\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.images-library-scope .lumina-view-toggle button.lumina-view-toggle--active {\n  background: var(--lumina-surface);\n  color: var(--lumina-primary);\n  box-shadow: 0 1px 3px rgba(25, 28, 30, 0.08);\n}\n\n.images-library-scope .lumina-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--lumina-on-surface);\n  background: var(--lumina-surface-container-high);\n  transition: background 0.2s, transform 0.15s;\n}\n\n.images-library-scope .lumina-btn-secondary:hover {\n  background: #d8dadc;\n}\n\nhtml.dark .images-library-scope .lumina-btn-secondary:hover {\n  background: var(--lumina-surface-container-high);\n}\n\n.images-library-scope .lumina-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1.25rem;\n  border-radius: 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--lumina-on-primary);\n  background: var(--lumina-primary);\n  transition: transform 0.15s, box-shadow 0.2s;\n}\n\n.images-library-scope .lumina-btn-primary:hover {\n  transform: scale(1.02);\n}\n\n.images-library-scope .lumina-btn-primary:active {\n  transform: scale(0.98);\n}\n\n/* Source chips */\n.images-library-scope .lumina-source-active {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--lumina-inverse-on-surface);\n  background: var(--lumina-inverse-surface);\n  box-shadow: 0 1px 3px rgba(25, 28, 30, 0.12);\n}\n\n.images-library-scope .lumina-source-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--lumina-on-surface-variant);\n  background: var(--lumina-surface-container-low);\n  border: 1px solid rgba(204, 195, 216, 0.35);\n  transition: border-color 0.2s, color 0.2s;\n}\n\n.images-library-scope .lumina-source-chip:hover {\n  border-color: rgba(99, 14, 212, 0.45);\n  color: var(--lumina-on-surface);\n}\n\n.images-library-scope .lumina-source-avatar {\n  display: flex;\n  height: 1.5rem;\n  width: 1.5rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  font-size: 0.625rem;\n  font-weight: 700;\n  background: rgba(99, 14, 212, 0.12);\n  color: var(--lumina-primary);\n}\n\n/* Sticky gallery bar */\n.images-library-scope .lumina-gallery-bar {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  margin-bottom: 1.5rem;\n  margin-left: calc(-1 * var(--lumina-margin));\n  margin-right: calc(-1 * var(--lumina-margin));\n  padding: 0.75rem var(--lumina-margin);\n}\n\n.images-library-scope .lumina-field {\n  padding: 0.5rem 0.875rem 0.5rem 2.25rem;\n  border-radius: 0.75rem;\n  border: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--lumina-on-surface);\n  background: var(--lumina-surface-container);\n  outline: none;\n  transition: box-shadow 0.2s;\n}\n\n.images-library-scope .lumina-field:focus {\n  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.2);\n}\n\n.images-library-scope .lumina-select {\n  padding: 0.5rem 0.875rem 0.5rem 2.25rem;\n  border-radius: 0.75rem;\n  border: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--lumina-on-surface);\n  background: var(--lumina-surface-container);\n  outline: none;\n  appearance: none;\n  min-width: 9rem;\n}\n\n.images-library-scope .lumina-select:focus {\n  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.2);\n}\n\n/* Day header */\n.images-library-scope .lumina-day-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--lumina-on-surface);\n}\n\n.images-library-scope .lumina-day-meta {\n  margin-left: 0.5rem;\n  font-weight: 400;\n  opacity: 0.6;\n  color: var(--lumina-on-surface-variant);\n}\n\n/* Fixed-width columns — balanced size (no 1fr stretch) */\n.images-library-scope .lumina-gallery-grid {\n  display: grid;\n  gap: 0.75rem;\n  grid-template-columns: repeat(auto-fill, 10.5rem);\n  justify-content: start;\n}\n\n@media (min-width: 640px) {\n  .images-library-scope .lumina-gallery-grid {\n    gap: 0.875rem;\n    grid-template-columns: repeat(auto-fill, 11.5rem);\n  }\n}\n\n@media (min-width: 1280px) {\n  .images-library-scope .lumina-gallery-grid {\n    grid-template-columns: repeat(auto-fill, 12rem);\n  }\n}\n\n.images-library-scope .lumina-gallery-grid--compact {\n  gap: 0.5rem;\n  grid-template-columns: repeat(auto-fill, 8.75rem);\n}\n\n@media (min-width: 640px) {\n  .images-library-scope .lumina-gallery-grid--compact {\n    grid-template-columns: repeat(auto-fill, 9.5rem);\n  }\n}\n\n/* Skeleton card in grid */\n.images-library-scope .lumina-skeleton-card {\n  overflow: hidden;\n  border-radius: 0.75rem;\n  border: 1px solid rgba(204, 195, 216, 0.25);\n  background: var(--lumina-surface);\n}\n\n.images-library-scope .lumina-skeleton-card .lumina-skeleton-media {\n  aspect-ratio: 4 / 3;\n}\n\n.images-library-scope .lumina-skeleton-card .lumina-skeleton-footer {\n  height: 2.25rem;\n  border-top: 1px solid rgba(204, 195, 216, 0.2);\n}\n\n/* Sticky top bar (no left sidebar) */\n.images-library-scope .lumina-top-bar {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  border-bottom: 1px solid rgba(204, 195, 216, 0.35);\n  background: rgba(247, 249, 251, 0.88);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\nhtml.dark .images-library-scope .lumina-top-bar {\n  border-bottom-color: rgba(71, 85, 105, 0.6);\n  background: rgba(15, 23, 42, 0.9);\n}\n\n.images-library-scope .lumina-top-search {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem 0.75rem 0.375rem 0.625rem;\n  border-radius: 9999px;\n  background: var(--lumina-surface-container);\n  transition: box-shadow 0.2s;\n}\n\n.images-library-scope .lumina-top-search:focus-within {\n  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.2);\n}\n\n.images-library-scope .lumina-top-search input {\n  width: 100%;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  font-size: 0.875rem;\n  color: var(--lumina-on-surface);\n  outline: none;\n}\n\n@media (min-width: 640px) {\n  .images-library-scope .lumina-top-search input {\n    width: 12rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .images-library-scope .lumina-top-search input {\n    width: 16rem;\n  }\n}\n\n.images-library-scope .lumina-page-body {\n  width: 100%;\n  max-width: 100%;\n  padding-left: var(--lumina-margin);\n  padding-right: var(--lumina-margin);\n  padding-top: 1.25rem;\n  padding-bottom: 2rem;\n}\n\n/* Gallery card */\n.images-library-scope .lumina-gallery-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 1rem;\n  border: 1px solid rgba(204, 195, 216, 0.25);\n  background: var(--lumina-surface);\n  box-shadow: 0 1px 2px rgba(25, 28, 30, 0.05);\n  transition: box-shadow 0.3s ease, transform 0.3s ease;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.images-library-scope .lumina-gallery-card img,\n.images-library-scope .lumina-gallery-card video {\n  -webkit-user-drag: none;\n  user-drag: none;\n  pointer-events: none;\n}\n\n.images-library-scope .lumina-marquee-surface {\n  cursor: default;\n}\n\n.images-library-scope .lumina-marquee-surface--active {\n  cursor: crosshair;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.images-library-scope .lumina-marquee-box {\n  pointer-events: none;\n}\n\n.images-library-scope .lumina-gallery-card:hover {\n  box-shadow: 0 12px 28px -8px rgba(99, 14, 212, 0.18);\n  transform: translateY(-2px);\n}\n\n.images-library-scope .lumina-gallery-card--selected {\n  box-shadow: 0 0 0 2px rgba(99, 14, 212, 0.45), 0 12px 28px -8px rgba(99, 14, 212, 0.15);\n}\n\n.images-library-scope .lumina-gallery-card .lumina-media {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n  background: var(--lumina-surface-container);\n}\n\n.images-library-scope .lumina-gallery-card .lumina-media img,\n.images-library-scope .lumina-gallery-card .lumina-media video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.images-library-scope .lumina-gallery-card:hover .lumina-media img,\n.images-library-scope .lumina-gallery-card:hover .lumina-media video {\n  transform: scale(1.05);\n}\n\n.images-library-scope .lumina-gallery-card .lumina-media-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent 55%);\n  opacity: 0;\n  transition: opacity 0.35s ease;\n  pointer-events: none;\n}\n\n.images-library-scope .lumina-gallery-card:hover .lumina-media-overlay {\n  opacity: 1;\n}\n\n.images-library-scope .lumina-ext-badge {\n  position: absolute;\n  bottom: 0.5rem;\n  right: 0.5rem;\n  z-index: 2;\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  font-size: 0.625rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(8px);\n}\n\n.images-library-scope .lumina-card-select {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  z-index: 3;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.images-library-scope .lumina-gallery-card:hover .lumina-card-select,\n.images-library-scope .lumina-gallery-card--selected .lumina-card-select {\n  opacity: 1;\n}\n\n.images-library-scope .lumina-card-actions {\n  position: absolute;\n  bottom: 0.5rem;\n  left: 0.5rem;\n  z-index: 3;\n  display: flex;\n  gap: 0.375rem;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: opacity 0.25s ease, transform 0.25s ease;\n}\n\n.images-library-scope .lumina-gallery-card:hover .lumina-card-actions {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.images-library-scope .lumina-action-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 9999px;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(6px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: background 0.2s, transform 0.15s;\n}\n\n.images-library-scope .lumina-action-icon:hover {\n  background: rgba(0, 0, 0, 0.65);\n  transform: scale(1.06);\n}\n\n.images-library-scope .lumina-action-icon--danger:hover {\n  background: rgba(186, 26, 26, 0.85);\n}\n\n.images-library-scope .lumina-card-footer {\n  padding: 0.625rem 0.75rem;\n}\n\n.images-library-scope .lumina-card-filename {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--lumina-on-surface);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.images-library-scope .lumina-card-meta {\n  margin-top: 0.125rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--lumina-on-surface-variant);\n}\n\n.images-library-scope .lumina-shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(110deg, #eceef0 0%, #f7f9fb 45%, #eceef0 90%);\n  background-size: 200% 100%;\n  animation: lumina-shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes lumina-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.images-library-scope .lumina-empty {\n  border-radius: 1.25rem;\n  border: 2px dashed rgba(204, 195, 216, 0.6);\n  background: rgba(255, 255, 255, 0.55);\n  padding: 3.5rem 1.5rem;\n  text-align: center;\n}\n\n.images-library-scope .lumina-stat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--lumina-on-surface-variant);\n  background: var(--lumina-surface-container-high);\n}\n\n/* Lightbox */\n.images-library-scope .lumina-lightbox-chrome {\n  background: linear-gradient(180deg, rgba(25, 28, 30, 0.88) 0%, transparent 100%);\n}\n\n.images-library-scope .lumina-lightbox-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.125rem;\n  padding: 0.25rem;\n  border-radius: 9999px;\n  background: rgba(25, 28, 30, 0.55);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.images-library-scope .lumina-lightbox-pill button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 9999px;\n  color: rgba(255, 255, 255, 0.88);\n  transition: background 0.2s, color 0.2s;\n}\n\n.images-library-scope .lumina-lightbox-pill button:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n}\n\n.images-library-scope .lumina-nav-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.75rem;\n  height: 2.75rem;\n  border-radius: 9999px;\n  color: var(--lumina-primary);\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 4px 20px rgba(25, 28, 30, 0.2);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.images-library-scope .lumina-nav-btn:hover {\n  transform: scale(1.06);\n}\n\n/* Legacy aliases used in modals */\n.images-library-scope .il-primary-gradient {\n  background: linear-gradient(135deg, #0f172a, #2563eb);\n  color: #fff;\n}\n\n.images-library-scope .il-shadow-elegant {\n  box-shadow: 0 0 20px rgba(15, 23, 42, 0.16);\n}\n\n/* Legacy purple accent classes → ink */\n.images-library-scope .text-\\[\\#630ed4\\],\n.images-library-scope .text-\\[\\#7c3aed\\] {\n  color: var(--lumina-primary) !important;\n}\n.images-library-scope .bg-\\[\\#630ed4\\],\n.images-library-scope .bg-\\[\\#7c3aed\\] {\n  background-color: var(--lumina-primary) !important;\n  color: var(--lumina-on-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
